const tileGridButtons = document.querySelectorAll('.tile-grid-next-button');

tileGridButtons.forEach(button => {
    const tileGrid = document.getElementById(button.getAttribute('aria-controls'));
    const tiles = tileGrid.querySelectorAll('.tile-grid__tile');

    button.addEventListener('click', () => {
        const tileWidth = tiles[0]?.offsetWidth;
        if (!tileWidth) {
            return;
        }

        tileGrid.scrollBy({
            top: 0,
            left: tileWidth,
            behavior: 'smooth',
        });
    });
});
